<template>
  <!-- 退件单 -->
  <div>
    <el-card class="mb5">
      <el-tabs v-model="activeName" style="margin-top: -10px" @tab-click="handleClick">
        <el-tab-pane name="0">
          <span slot="label">
            {{ $t('trajectory.newOrderReturn') }}
          </span>
        </el-tab-pane>
        <el-tab-pane
          name="1"
        ><span slot="label">
          {{ $t('trajectory.originalOrderReturnD2D') }}
        </span>
        </el-tab-pane>
      </el-tabs>
      <div style="margin-bottom: 15px">
        <!-- 退件单 -->
        <div style="font-weight: bold; font-size: 14px; color: #606266">
          {{ $t('collectionCenter.returnNote') }}
        </div>
        <el-input
          v-model="returnNoteVal"
          :placeholder="$t('collectionCenter.scanOrInputParcelNumber')"
          clearable
          size="small"
          style="width: 300px"
          @keyup.enter.native.stop="(e) => addReturnData(e)"
        />
      </div>
      <div style="margin-bottom: 20px">
        <span style="font-weight: bold; font-size: 14px; color: #606266; margin-right: 20px">
          {{ $t('collectionCenter.scanned') }}：<span style="color: #00A551">{{
            tableData.length
          }}</span>
        </span>
        <!--  发起退件  -->
        <el-button
          size="small" type="primary" @click="toReturn"
        >{{ $t('collectionCenter.InitiateRejection') }}
        </el-button>
      </div>
    </el-card>
    <el-card>
      <el-table
        :data="tableData"
        :header-cell-style="{ background: '#f2f2f2', color: 'black', 'text-align': 'center' }"
        :max-height="600"
        border
        style="width: 100%"
      >
        <!-- 序号 -->
        <el-table-column
          :label="$t('collectionCenter.ind')" align="center" prop="ind"
          width="60"
        />
        <!-- 运单号 -->
        <el-table-column
          :label="$t('collectionCenter.waybillNumber')"
          align="center"
          prop="waybillNumber"
        />
        <!-- 扫描单号 -->
        <el-table-column
          :label="$t('collectionCenter.ScanNumber')"
          align="center"
          prop="ScanNumber"
        />
        <!-- 扫描人 -->
        <el-table-column :label="$t('collectionCenter.scanner')" align="center" prop="person" />
        <!-- 扫描时间 -->
        <el-table-column :label="$t('collectionCenter.scanTime')" align="center" prop="scanTime" />
        <el-table-column :label="$t('collectionCenter.operation')" align="center">
          <template slot-scope="scope">
            <el-popconfirm
              :title="$t('collectionCenter.deleteSure')" @confirm="del(scope.$index)"
            ><!-- 确定删除吗？ -->
              <div slot="reference" style="cursor: pointer; color: red">
                {{ $t('collectionCenter.Delete') }}
              </div>
            <!-- 删除 -->
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </el-card>
    <el-dialog
      :before-close="handleClose"
      :close-on-click-modal="false"
      :show-close="false"
      :title="$t('collectionCenter.tips')"
      :visible.sync="dialogVisible"
      class="returnDialogClass"
      width="50%"
    >
      <div>
        <span>{{ $t('collectionCenter.initiateReturnTotal') }}：{{ sumbitMsg.reverseTotal }}</span>
        <div style="margin-top: 20px; margin-bottom: 20px">
          <span
            style="display: inline-block; width: 50%"
          >{{ $t('collectionCenter.orderSuccessful') }}：{{ sumbitMsg.reverseSuccess }}</span>
          <span
            style="display: inline-block; width: 50%"
          >{{ $t('collectionCenter.orderFailure') }}：{{
            sumbitMsg.reverseFailList ? sumbitMsg.reverseFailList.length : 0
          }}</span>
        </div>
        <div v-if="sumbitMsg.reverseFailList && sumbitMsg.reverseFailList.length > 0">
          <span>{{ $t('collectionCenter.orderFailedOrder') }}：</span>
          <el-table :data="sumbitMsg.reverseFailList" :max-height="500" :show-header="false">
            <el-table-column :label="$t('collectionCenter.ind')" prop="ind" width="60" />
            <el-table-column :label="$t('collectionCenter.order')" prop="waybillNumber" />
            <el-table-column :label="$t('collectionCenter.reason')" prop="failReason" />
          </el-table>
        </div>
      </div>
      <span slot="footer">
        <el-button size="small" type="primary" @click="handleClose">{{
          $t('collectionCenter.close')
        }}</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import {
  reverseScan,
  reverseScanD2D,
  reverseSumbit,
  reverseSumbitD2D
} from '@/api/automaticSorting';
import dayjs from 'dayjs';

export default {
  name: 'ReturnNote',
  data() {
    return {
      activeName: '0',
      returnNoteVal: '',
      tableData: [],
      dialogVisible: false,
      sumbitMsg: {}
    };
  },
  methods: {
    handleClick(val) {
      console.log(val.name, 'handleClick', this.activeName);
      // this.activeName = val.name;
    },
    addReturnData(e) {
      // 第一步：阻止事件默认行为（关键）
      e.preventDefault();
      e.stopPropagation();
      console.log(132);
      if (!this.returnNoteVal) return;
      if (this.activeName === '0') {
        reverseScan(this.returnNoteVal).then((res) => {
          if (res.code === 200) {
            const isAdd = this.tableData.some((el) => {
              if (this.tableData.length >= 1) {
                return el.waybillNumber === res.data.forwardWaybillNumber;
              }
            });
            if (isAdd) {
              this.$message({
                message: this.$t('collectionCenter.repeatDataTips'),
                type: 'warning'
              });
              return;
            }
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.tableData.push({
              ind: this.tableData.length + 1,
              waybillNumber: res.data.forwardWaybillNumber,
              ScanNumber: res.data.scanOrderNumber,
              person: this.$store.state.user.realName,
              scanTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
            });
            this.returnNoteVal = '';
          }
        });
      } else {
        reverseScanD2D(this.returnNoteVal).then((res) => {
          if (res.code === 200) {
            const isAdd = this.tableData.some((el) => {
              if (this.tableData.length >= 1) {
                return el.waybillNumber === res.data.waybillNumber;
              }
            });
            if (isAdd) {
              this.$message({
                message: this.$t('collectionCenter.repeatDataTips'),
                type: 'warning'
              });
              return;
            }
            this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
            this.tableData.push({
              ind: this.tableData.length + 1,
              waybillNumber: res.data.waybillNumber,
              ScanNumber: res.data.scanOrderNumber,
              person: this.$store.state.user.realName,
              scanTime: dayjs().format('YYYY-MM-DD HH:mm:ss')
            });
            this.returnNoteVal = '';
          }
        });
      }
    },
    del(ind) {
      this.tableData.splice(ind, 1);
    },
    toReturn() {
      if (this.tableData.length <= 0) {
        this.$message.warning(this.$t('GlobalSetObj.notDataUpload'));
        return;
      }
      const loading = this.$loading({
        fullscreen: true,
        lock: true,
        spinner: 'el-icon-loading',
        text: 'loading...',
        background: 'rgba(250, 250, 250, 0.6)'
      });
      const form = {
        waybillNumbers: this.tableData.map((arr) => arr.waybillNumber)
      };
      if (this.activeName === '0') {
        reverseSumbit(form)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
              this.sumbitMsg = res.data;
              this.sumbitMsg.reverseFailList = res.data.reverseFailList.map((arr, ind) => {
                return {
                  ind: ind + 1,
                  waybillNumber: arr.waybillNumber,
                  failReason: arr.failReason
                };
              });
              this.dialogVisible = true;
              this.tableData = [];
            }
          })
          .finally(() => {
            loading.close();
          });
      } else {
        reverseSumbitD2D(form)
          .then((res) => {
            if (res.code === 200) {
              this.$message.success(this.$t('basicData.TheOperationSucceeded')); // 操作成功
              this.sumbitMsg = res.data;
              this.sumbitMsg.reverseFailList = res.data.reverseFailList.map((arr, ind) => {
                return {
                  ind: ind + 1,
                  waybillNumber: arr.waybillNumber,
                  failReason: arr.failReason
                };
              });
              this.dialogVisible = true;
              this.tableData = [];
            }
          })
          .finally(() => {
            loading.close();
          });
      }
    },
    handleClose() {
      this.dialogVisible = false;
      this.sumbitMsg = {};
    }
  }
};
</script>

<style lang="scss" scoped>
.returnDialogClass ::v-deep .el-dialog__footer {
  text-align: center;
}

.right {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
</style>
